import React from "react";
import Logo from "../images/LogoBig.png";
import logotxt from "../images/logotxt.png";
import Wave from "react-wavify";

const guidelinesData = {
  "guidelines": [
    {
      "category": "USER GUIDELINES FOR WATERLOGGING",
      "steps": [
        "Stay Informed: Keep abreast of weather forecasts and updates.",
        "Avoid Flooded Areas: Stay away from waterlogged or flooded areas.",
        "Emergency Contacts: Have emergency contact numbers readily available.",
        "Evacuation Plan: Develop a family evacuation plan.",
        "Emergency Kit: Prepare an emergency kit with essential supplies.",
        "Secure Valuables: Elevate or secure valuable items.",
        "Avoid Electrical Hazards: Stay away from electrical appliances in waterlogged areas.",
        "Turn Off Utilities: Turn off gas, electricity, and water mains if flooding is imminent.",
        "Wait for the All-Clear: Stay indoors and wait for the all-clear.",
        "Check on Neighbors: Check on neighbors, especially those who may need assistance.",
        "Community Assistance: Collaborate with neighbors and community members.",
        "Maintain Drainage Systems: Participate in local community efforts to maintain drainage systems.",
        "Document Damage: Take photographs of damage caused by waterlogging.",
        "Report Incidents to Jal-Suraksha: Report incidents to Jal-Suraksha for prompt action."
      ]
    }
  ]
};

const FixedBottomAnimation = () => (
  <div className="absolute bottom-0 left-0 right-0">
    <Wave
      mask="url(#mask)"
      fill="#49B5F0"
      options={{
        height: 10,
        amplitude: 24,
        speed: 0.3,
        points: 3,
      }}
    >
      <defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)">
          <stop offset="0" stopColor="white" />
          <stop offset="0.5" stopColor="black" />
        </linearGradient>
      </defs>
    </Wave>
  </div>
);

const LoggingWater = () => {
  return (
    <div className="relative bg-white overflow-y-auto pb-20">
      <div className="w-full text-center">
        <div className="mb-2 mx-auto md:w-[7.5%] md:h-[7.5%] w-[15%] h-[15%] mt-0">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Ministry_of_Jal_Shakti.svg"
            alt=""
          />
        </div>
        <div className="mb-2 mx-auto md:w-[2%] w-[4%] mt-0">
          <img
            src={Logo}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="mb-2 mx-auto md:w-[10%] w-[20%] mt-2">
          <img
            src={logotxt}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="p-6 bg-white text-black rounded border border-gray-800">
          <h1 className="text-3xl font-bold mb-4 text-center border-b border-black pt-2">{guidelinesData.guidelines[0].category}</h1>
          <div className="text-left text-xl">
            <ul className="list-disc list-inside">
              {guidelinesData.guidelines[0].steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>
          </div>
          <div className="p-10"></div>
        </div>
      </div>
      <FixedBottomAnimation />
    </div>
  );
};

export default LoggingWater;
